import { ProgressBarInfo } from '@apply/components';

/** Same rule ZipCodeBox validates against: 5 digits, optionally followed by -4 digits. */
export const isValidZipCode = (value: string) => /^\d{5}(-\d{4})?$/.test(value);

export const purchaseTypes = ['New', 'Future'] as const;
export type PurchaseType = (typeof purchaseTypes)[number];

export interface PropertyForm {
    streetAddress: string;
    city: string;
    /** State abbreviation (e.g. 'TX'), as StateDropDown stores it. */
    state: string;
    /** County name within the selected state. */
    county: string;
    zip: string;
    purchasedYear: number | undefined;
    purchaseType: PurchaseType | '';
    /** Yes / No; undefined until the user picks one. */
    selfOwned: boolean | undefined;
    propertyNotes: string;
}

export const emptyPropertyForm: PropertyForm = {
    streetAddress: '',
    city: '',
    state: '',
    county: '',
    zip: '',
    purchasedYear: undefined,
    purchaseType: '',
    selfOwned: undefined,
    propertyNotes: '',
};

const hasText = (value: string) => value.trim().length > 0;

/** Completion for the Property step, computed from the form data so it's known whether or not the step is open. */
export const getPropertyProgress = (form: PropertyForm): ProgressBarInfo => {
    const fieldsComplete = [
        hasText(form.streetAddress),
        hasText(form.city),
        hasText(form.state),
        hasText(form.county),
        isValidZipCode(form.zip),
        form.purchasedYear !== undefined && form.purchasedYear !== null,
        hasText(form.purchaseType),
        form.selfOwned !== undefined,
        hasText(form.propertyNotes),
    ];
    return {
        numberComplete: fieldsComplete.filter(Boolean).length,
        total: fieldsComplete.length,
    };
};
